import { commentLikeQueries } from "@circle-react/lib/queries/commentLikes";
import type { Comment } from "@circle-react/types/Comment";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

interface UseLikesListParams {
  comment: Comment;
}

export const useLikesList = ({ comment }: UseLikesListParams) => {
  const { data, isInitialLoading, fetchNextPage, hasNextPage } =
    useInfiniteQuery(commentLikeQueries.list(comment.id));

  const members = useMemo(
    () => data?.pages.flatMap(page => page.records) ?? [],
    [data],
  );
  const totalCount = data?.pages.at(-1)?.count;

  return {
    members,
    totalCount,
    isInitialLoading,
    fetchNextPage,
    hasNextPage,
  };
};
